<template>
  <div>
    <div v-if="group.portal == '3'">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="6" md="2">
              <v-list two-line>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      <span v-if="group.portal == 0">V2</span>
                      <span v-if="group.portal == 1">V3</span>
                      <span v-if="group.portal == 2">V4</span>
                      <span v-if="group.portal == 3">V5</span>
                    </v-list-item-title>
                    <v-list-item-subtitle>Version</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="6" md="2">
              <v-list two-line>
                <v-list-item
                  :disabled="!isGrantedUser()"
                  @click="portalPresentationModelDialog = true"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      <span v-if="group.isBuiltin">
                        <b>({{ group.portalOptions.name }})</b>
                      </span>
                      <span v-else>-</span>
                    </v-list-item-title>
                    <v-list-item-subtitle>Template</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="6" md="2">
              <v-list two-line>
                <v-list-item
                  :disabled="!isGrantedUser()"
                  @click="portalPresentationModelDialog = true"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      <span>{{ group.portalName }}</span>
                    </v-list-item-title>
                    <v-list-item-subtitle>Modèle</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="6" md="2">
              <v-list two-line>
                <v-list-item
                  :disabled="!isGrantedUser()"
                  @click="portalPresentationOtherDialog = true"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      {{
                        group.portalConfiguration.weather_city != ""
                          ? group.portalConfiguration.weather_city
                          : "-"
                      }}
                    </v-list-item-title>
                    <v-list-item-subtitle>Ville météo</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="6" md="2">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-list two-line>
                    <v-list-item
                      :disabled="!isGrantedUser()"
                      @click="portalPresentationOtherDialog = true"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          {{
                            group.portalConfiguration.welcome_url != ""
                              ? group.portalConfiguration.welcome_url
                              : "-"
                          }}
                        </v-list-item-title>
                        <v-list-item-subtitle>Welcome URL</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </template>
                <span>{{
                  group.portalConfiguration.welcome_url != ""
                    ? group.portalConfiguration.welcome_url
                    : "-"
                }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card class="mt-2 pa-0">
        <v-card-text class="pa-0">
          <v-container fluid>
            <v-row>
              <v-col cols="12" md="8" class="border-right relative">
                <div class="text-center full-height">
                  <iframe
                    :src="previewUrl"
                    style="
                      width: 100%;
                      max-width: 400px;
                      height: calc(100% - 16px);
                      overflow: auto;
                    "
                    class="mt-2"
                    v-if="previewUrl"
                  />
                  <v-subheader v-else>
                    Veuillez sélectionner un portail du groupe pour le
                    visualiser.
                  </v-subheader>
                </div>
                <preview-portal-fab
                  :nas="selectedPortalNas"
                  v-if="selectedPortalNas"
                ></preview-portal-fab>
              </v-col>
              <v-col cols="12" md="4" class="pa-0">
                <v-card class="pa-0" flat>
                  <v-card-title>Choix du portail de visualisation</v-card-title>
                  <v-card-text>
                    <v-select
                      :items="groupPortals"
                      :disabled="!hasPortals"
                      :loading="loadingPortals"
                      v-model="selectedPreviewPortal"
                      return-object
                      item-value="id"
                      item-text="description"
                      :hide-details="!loadingPortals && hasPortals"
                      :hint="
                        !loadingPortals && !hasPortals
                          ? 'Le groupe n\'a pas de portail en héritage'
                          : ''
                      "
                      dense
                      :persistent-hint="!loadingPortals && !hasPortals"
                    ></v-select>
                  </v-card-text>
                </v-card>
                <v-divider></v-divider>
                <v-card class="pa-0" flat>
                  <v-card-title>Bandeau</v-card-title>
                  <v-card-text>
                    <group-banner-footer
                      :group="group"
                      type="banner"
                      v-on:refresh-preview="reloadPreview"
                    ></group-banner-footer>
                  </v-card-text>
                </v-card>
                <v-divider></v-divider>
                <v-card class="pa-0" flat>
                  <v-card-title>Footer</v-card-title>
                  <v-card-text>
                    <group-banner-footer
                      :group="group"
                      type="footer"
                      v-on:refresh-preview="reloadPreview"
                    ></group-banner-footer>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card class="pa-0" flat>
                    <v-card-title>Fond</v-card-title>
                    <v-card-text>
                      <group-background
                        :group="group"
                        v-on:refresh-preview="reloadPreview"
                      ></group-background>
                    </v-card-text>
                  </v-card>
                  <v-divider></v-divider>
                  <v-card :loading="colorsLoading" flat class="pb-2">
                    <v-card-title>
                      Couleurs
                      <v-spacer></v-spacer>

                      <div class="ml-3">
                        <v-btn
                          v-if="editMode"
                          @click="cancelThemeChanges"
                          icon
                          small
                        >
                          <v-icon>mdi-cancel</v-icon>
                        </v-btn>
                        <v-btn
                          v-else
                          icon
                          @click="editMode = true"
                          :disabled="
                            !group.portalConfigurationModel.has_color ||
                            !isGrantedUser()
                          "
                          small
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </div>
                    </v-card-title>
                    <v-card-text class="py-0">
                      <edit-portal-presentation-theme-form
                        v-if="group.portal == '3'"
                        :portalOptionsId="group.portalOptionsId"
                        :isInherit="false"
                        :isBuiltIn="group.isBuiltin"
                        :portalConfiguration.sync="group.portalConfiguration"
                        :portalConfigurationModel="
                          group.portalConfigurationModel
                        "
                        :id="String(group.id)"
                        :group="group"
                        :partner="group.partner"
                        :rules="rules"
                        :editMode="editMode"
                        ref="editTheme"
                        @open:palette="paletteDrawer = true"
                        @save:colors="saveTheme"
                        @cancel:colors="cancelThemeChanges"
                      ></edit-portal-presentation-theme-form>
                      <v-row class="mt-0">
                        <v-col cols="12" md="6" class="pt-0">
                          <palette-chooser
                            :disabled="!editMode || !isGrantedUser()"
                            :portalColors.sync="
                              group.portalConfiguration.colors
                            "
                            :banner="group.bannerPath"
                            :background="group.backgroundPath"
                            :open.sync="paletteDrawer"
                          ></palette-chooser>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      <edit-portal-presentation-model-form
        v-if="group.portal == '3'"
        :isInherit="false"
        :portalConfiguration.sync="group.portalConfiguration"
        :portalConfigurationModel="group.portalConfigurationModel"
        :isBuiltIn="group.isBuiltin"
        :portalOptionsId="group.portalOptionsId"
        :updatePortalConfiguration="updatePortalConfigurationModel"
        :id="String(group.id)"
        :group="null"
        :isGroup="true"
        :partner="group.partner"
        :portalPresentationModelDialog.sync="portalPresentationModelDialog"
      ></edit-portal-presentation-model-form>
      <edit-portal-presentation-other-form
        v-if="group.portal == '3' && portalPresentationOtherDialog"
        :isInherit="false"
        :portalOptionsId="group.portalOptionsId"
        :isBuiltIn="group.isBuiltin"
        :portalConfiguration="group.portalConfiguration"
        :portalConfigurationModel="group.portalConfigurationModel"
        :updatePortalConfiguration="updatePortalConfigurationSparse"
        :id="String(group.id)"
        :group="null"
        :partner="group.partner"
        :portalPresentationOtherDialog.sync="portalPresentationOtherDialog"
        :rules="rules"
      ></edit-portal-presentation-other-form>
    </div>
    <div v-else>
      <v-alert type="warning">
        <v-row align="center">
          <v-col class="grow">
            Il faut migrer le groupe pour pouvoir le configurer.
          </v-col>
        </v-row>
      </v-alert>
    </div>
  </div>
</template>
<script>
import {
  defineComponent,
  ref,
  toRefs,
  onMounted,
  computed,
  watch,
  onBeforeMount,
  toRef,
} from "@vue/composition-api";
import { useGroup } from "@/composables/group";
import global from "@/composables/global";
import EditPortalPresentationModelForm from "@/components/PortalConfiguration/EditPortalPresentationModelForm";
import EditPortalPresentationThemeForm from "@/components/PortalConfiguration/EditPortalPresentationThemeForm";
import PaletteChooser from "@/components/ClientPortal/PaletteChooser.vue";
import GroupBannerFooter from "@/components/Group/GroupBannerFooter";
import GroupBackground from "@/components/Group/GroupBackground";
import PreviewPortalFab from "@/components/ClientPortal/PreviewPortalFab";
import EditPortalPresentationOtherForm from "@/components/PortalConfiguration/EditPortalPresentationOtherForm";
import { useIframePreview } from "@/composables/iframe-preview";
import { useRoles } from "../../composables/roles";
import { useClientPortal } from "@/composables/client-portal";

export default defineComponent({
  components: {
    EditPortalPresentationModelForm,
    EditPortalPresentationThemeForm,
    PaletteChooser,
    GroupBannerFooter,
    GroupBackground,
    PreviewPortalFab,
    EditPortalPresentationOtherForm,
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    /* Import des API */
    const {
      data,
      updatePortalConfigurationModel,
      updatePortalConfigurationSparse,
    } = useGroup();
    const { isGrantedUser } = useRoles();
    const { data: portalData, listClientPortals } = useClientPortal();
    const { reloadPreview } = useIframePreview();
    const colorFormData = ref({});

    /* Cycle de vie */
    onBeforeMount(async () => {
      await listClientPortals({
        group: props.group.id,
        isActive: true,
        isInheritOnly: 1,
      });
      groupPortals.value = portalData.clientPortals.data;
    });
    onMounted(() => {
      // Impossible de faire un deep clone via les méthodes connues. La copie est toujours faite par référence no matter what et l'objet originalColors était mis à jour avec les nouvelles valeurs sans qu'on lui ait demandé
      originalColors.primary = props.group.portalConfiguration.colors
        ? props.group.portalConfiguration.colors.primary
        : null;
      originalColors.secondary = props.group.portalConfiguration.colors
        ? props.group.portalConfiguration.colors.secondary
        : null;
      originalColors.theme = props.group.portalConfiguration.colors
        ? props.group.portalConfiguration.theme
        : null;
    });

    /* Variables */
    const editMode = ref(false);
    const editTheme = ref(null);
    let originalColors = {
      primary: "",
      secondary: "",
      theme: "",
    };
    const previewUrl = ref("");
    const selectedPreviewPortal = ref(null);
    const colorsLoading = ref(false);
    const baseUrl = config.VUE_APP_API_PUBLIC;
    const groupPortals = ref([]);
    const paletteDrawer = ref(false);

    /* Computed */
    const hasPortals = computed(function () {
      return groupPortals.value.length > 0;
    });
    const selectedPortalNas = computed(function () {
      if (selectedPreviewPortal.value) {
        const portalActiveNasTab = selectedPreviewPortal.value.nas.filter(
          (x) => x.active == 1
        );
        if (portalActiveNasTab.length > 0) {
          return portalActiveNasTab[0];
        } else {
          return null;
        }
      } else {
        return null;
      }
    });

    /* Méthodes */
    const saveTheme = async function () {
      editMode.value = false;
      colorsLoading.value = true;
      colorFormData.value = {
        colors: props.group.portalConfiguration.colors,
        theme: props.group.portalConfiguration.theme,
      };
      await updatePortalConfigurationSparse(
        String(props.group.id),
        colorFormData.value
      );
      colorsLoading.value = false;
      originalColors.primary = props.group.portalConfiguration.colors.primary;
      originalColors.secondary =
        props.group.portalConfiguration.colors.secondary;
      originalColors.theme = props.group.portalConfiguration.theme;
      reloadPreview();
    };
    const cancelThemeChanges = function () {
      props.group.portalConfiguration.colors.primary = originalColors.primary;
      props.group.portalConfiguration.colors.secondary =
        originalColors.secondary;
      props.group.portalConfiguration.colors.background =
        originalColors.background;
      props.group.portalConfiguration.colors.opacity = originalColors.opacity;
      props.group.portalConfiguration.theme = originalColors.theme;
      editMode.value = false;
    };

    /* Watchers */
    watch(
      () => selectedPortalNas.value,
      (newValue) => {
        if (newValue) {
          previewUrl.value = `${baseUrl}login-url.php?id=${newValue.nasIdentifier}`;
        } else {
          previewUrl.value = "";
        }
      }
    );

    return {
      ...toRefs(data),
      updatePortalConfigurationSparse,
      editMode,
      hasPortals,
      saveTheme,
      cancelThemeChanges,
      editTheme,
      previewUrl,
      selectedPortalNas,
      reloadPreview,
      colorsLoading,
      selectedPreviewPortal,
      global,
      isGrantedUser,
      groupPortals,
      paletteDrawer,
      loadingPortals: toRef(portalData, "isLoading"),
      updatePortalConfigurationModel,
    };
  },
});
</script>
